import React, { Component } from 'react';
import { Badge } from 'reactstrap';
import { Fragment } from 'react';

export class WalkSlot extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        let { walk } = this.props;

        return (
            <Badge className='planningbadge'>
                <h4>#{walk.GroupId} {walk.ActivityType + '(' + walk.Session + ')'}</h4>
                <h5>{walk.Walker.FirstName} {walk.Walker.LastName + '(' + walk.Walker.CoveredPostcodes + ')'}</h5>
                {walk.Pets.map((pet, key) =>
                    <Fragment key={key}>
                        <span style={{ 'cursor': 'pointer' }} onClick={this.onClicked.bind(this, pet.AssignedWalkId)}>
                            <p>{pet.FullName + ' - ' + pet.OwnerName + '(' + pet.Postcode + ')'}</p>
                        </span>
                    </Fragment>
                )}
            </Badge>
        );
    }

    onClicked(id) {
        this.props.onClick(id)
    }
}